import { useEffect } from "react";
import { withRouter } from "react-router-dom";

/**
 * Only these routes may load inside an iframe; all other routes break out to the top window.
 *
 * Matching: exact path or subpath (`/link` matches `/link` and `/link/foo`).
 * Add strings starting with `/`.
 */
const IFRAME_ALLOWED_PATH_PREFIXES = [
   "/callback",
   "/fhir",
   "/callback_standalone",
   "/close_callback",
   "/vim_callback",
   "/vim"
];

function pathAllowsIframe(pathname) {
   const path = pathname.split("?")[0];
   return IFRAME_ALLOWED_PATH_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

/** Break out of iframe unless host is exempt or route is in the allow list. */
function IframeTopBreakout({ location }) {
   const { pathname } = location;
   useEffect(() => {
      if (window !== window.top && !pathAllowsIframe(pathname)) {
         window.top.location.href = window.location.href;
      };
   }, [pathname]);
   return null;
}

export default withRouter(IframeTopBreakout);
